<div [hidden]="!ViewReady">
    <h1 class="mat-h1">Facilitators</h1>
    <div>
        The following table lists the currently active facilitators for the IRIS System. You may use the tools provided below to add a
        new facilitator to the system, remove an existing facilitator, or reinstate a previously removed facilitator.
    </div>
    <button type="button" mat-raised-button color="primary" (click)="ShowFacilitatorForm()">Add New Facilitator</button>
    <!-- <div class="margin-top">
        <mat-checkbox [(ngModel)]="ShowInactiveFacilitators" (change)="UpdateFiltering()">Show Inactive Facilitators</mat-checkbox>
    </div> -->
    <table class="fullwidth" *ngIf="!SmallDisplay" mat-table [dataSource]="FacilitatorsSource" matSort matSortActive="LastName">
        <ng-container matColumnDef="LastName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Name</th>
            <td mat-cell *matCellDef="let fac">
                <div>{{ fac.LastName | titleCase }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="FirstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
            <td mat-cell *matCellDef="let fac">
                <div>{{ fac.FirstName | titleCase }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="SAPID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SAP #</th>
            <td mat-cell *matCellDef="let fac">
                <div>{{ fac.SAPID }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="LocalJobTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell *matCellDef="let fac">
                <div>{{ fac.LocalJobTitle }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Active?</th>
            <td mat-cell *matCellDef="let fac">
                <div>{{ fac.Active | yesNo }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>Action(s)</th>
            <td mat-cell *matCellDef="let fac">
                <button type="button" *ngIf="fac.Active === true" mat-raised-button color="warn" (click)="RemoveFacilitator(fac)">
                    Remove
                </button>
                <button type="button" *ngIf="fac.Active !== true" mat-raised-button color="warn" (click)="RestoreFacilitator(fac)">
                    Reactivate
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let fac" [attr.colspan]="VisibleHeaders?.length">
                <em>There are no facilitators defined and/or active in the IRIS system at this time.</em>
            </td>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <th mat-header-cell *matHeaderCellDef>Facilitators</th>
            <td mat-cell *matCellDef="let fac">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Last Name</div>
                        <div>{{ fac.LastName | titleCase }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>First Name</div>
                        <div>{{ fac.FirstName | titleCase }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>SAP #</div>
                        <div>{{ fac.SAPID }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Title</div>
                        <div>{{ fac.LocalJobTitle }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Active?</div>
                        <div>{{ fac.Active | yesNo }}</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <button
                            type="button"
                            *ngIf="fac.Active === true"
                            mat-raised-button
                            color="warn"
                            (click)="RemoveFacilitator(fac)"
                        >
                            Remove
                        </button>
                        <button
                            type="button"
                            *ngIf="fac.Active !== true"
                            mat-raised-button
                            color="warn"
                            (click)="RestoreFacilitator(fac)"
                        >
                            Reactivate
                        </button>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: VisibleColumns; let $even = even"
            [class.primarybackground50]="$even && !!row.Active"
            [class.inactive]="!row.Active"
        ></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="20" [length]="FacilitatorsSource?.data?.length"></mat-paginator>
</div>
